module.exports = __webpack_public_path__ + "img/case9.69bbb07a.jpg";